// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-button{width:-moz-fit-content;width:fit-content;display:block;margin:var(--base-button-margin);height:auto;border-radius:5px}.base-button:disabled,.base-button[disabled=true]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
